import { type CollectionStoreSummary } from '@Src/types/collectionStoreTypes';
import { type DeliveryStoreSummary } from '@Src/types/deliveryStoreTypes';

export const getStoreOrderUrl = ({
  isCollection,
  storeSummary,
  deliveryLocationId,
  shouldForceCollectionStoreUrl,
}: {
  isCollection: boolean;
  storeSummary?: CollectionStoreSummary | DeliveryStoreSummary;
  deliveryLocationId?: number;
  shouldForceCollectionStoreUrl?: boolean;
}): string | undefined => {
  if (storeSummary?.VirtualRestaurantId && storeSummary?.PhysicalRestaurantId) {
    if (isCollection || shouldForceCollectionStoreUrl) {
      return `/order#/restaurant/${storeSummary.VirtualRestaurantId}/collection/${storeSummary.PhysicalRestaurantId}`;
    } else if (!isCollection && deliveryLocationId) {
      return `/order#/restaurant/${storeSummary.VirtualRestaurantId}/delivery/${deliveryLocationId}`;
    }
  }
  return undefined;
};

export const navigateToWebOrder = ({
  isCollection,
  storeSummary,
  deliveryLocationId,
}: {
  isCollection: boolean;
  storeSummary?: CollectionStoreSummary | DeliveryStoreSummary;
  deliveryLocationId?: number;
}): void => {
  const orderUrl = getStoreOrderUrl({
    isCollection,
    storeSummary,
    deliveryLocationId,
  });
  if (orderUrl) {
    const pathName = window.location.pathname;
    // only get start of path in case index page is on a different url
    const formattedPathName = pathName.split('/')[1];
    if (formattedPathName === '') {
      window.location.replace(`${orderUrl}`);
    } else {
      window.location.replace(`/${formattedPathName}${orderUrl}`);
    }
  }
};
